import { IconButton, Stack } from "@material-ui/core";
import { ThumbDown, ThumbDownOutlined, ThumbUp, ThumbUpAltOutlined } from "@material-ui/icons";
import { db } from "firebaseConfig";
import firebase from "firebase/compat";
import { preventBubbling } from "utils/listings/helper";
import type { FavoriteListingsOfContact } from "../../../@types/sharedSchema";

type ListingCardLikesProps = {
  small?: boolean;
  listingId: string;
  favoriteListingsOfContact: FavoriteListingsOfContact;
};

export function ListingCardLikes({
  small,
  listingId,
  favoriteListingsOfContact
}: ListingCardLikesProps): JSX.Element {
  const listingLiked = favoriteListingsOfContact.listingIdsUserLiked?.includes(listingId);
  const listingDisliked = favoriteListingsOfContact.listingIdsUserDisliked?.includes(listingId);

  const manageLike = (type: "like" | "dislike") => async (): Promise<void> => {
    const alreadyLiked = type === "like" && listingLiked;
    const alreadyDisliked = type === "dislike" && listingDisliked;

    const shouldResetLike = alreadyLiked || alreadyDisliked;

    if (shouldResetLike) {
      await db
        .collection("favorite-listings-of-contact")
        .doc(favoriteListingsOfContact.id)
        .update({
          listingIdsUserLiked: firebase.firestore.FieldValue.arrayRemove(listingId),
          listingIdsUserDisliked: firebase.firestore.FieldValue.arrayRemove(listingId)
        });
      return;
    }

    if (type === "like") {
      await db
        .collection("favorite-listings-of-contact")
        .doc(favoriteListingsOfContact.id)
        .update({
          listingIdsUserLiked: firebase.firestore.FieldValue.arrayUnion(listingId),
          listingIdsUserDisliked: firebase.firestore.FieldValue.arrayRemove(listingId)
        });
    } else {
      await db
        .collection("favorite-listings-of-contact")
        .doc(favoriteListingsOfContact.id)
        .update({
          listingIdsUserLiked: firebase.firestore.FieldValue.arrayRemove(listingId),
          listingIdsUserDisliked: firebase.firestore.FieldValue.arrayUnion(listingId)
        });
    }
  };

  const buttonSize = small ? "small" : "medium";

  return (
    <Stack justifyContent="center" direction="row" gap={1}>
      <IconButton
        size={buttonSize}
        color={listingDisliked ? "error" : "default"}
        onClick={preventBubbling(manageLike("dislike"))}
      >
        {listingDisliked ? <ThumbDown /> : <ThumbDownOutlined />}
      </IconButton>
      <IconButton
        size={buttonSize}
        color={listingLiked ? "success" : "default"}
        onClick={preventBubbling(manageLike("like"))}
      >
        {listingLiked ? <ThumbUp /> : <ThumbUpAltOutlined />}
      </IconButton>
    </Stack>
  );
}
